//import React from "react";
import { NavigateFunction, RouteObject } from "react-router-dom";
import OP_Operations from "../../../Containers/OperationsScreens/op_operations";
import OP_Animals from "../../../Containers/OperationsScreens/op_animals";
import OP_QuickEntry from "../../../Containers/OperationsScreens/op_quickEntry";

/* eslint-disable */
export enum Pages {
  home="./",
  op_operations="op_operations",
  op_animals = "op_animals",
  op_quickEntry = "op_quickentry",
}
/* eslint-enable */

export const Router = [{
  element: null,
  children: [
    {index: true, path:`/${Pages.op_operations}`, element:<OP_Operations/>},
    {path:`/${Pages.op_animals}`, element:<OP_Animals/>},
    {path:`/${Pages.op_quickEntry}`, element:<OP_QuickEntry/>}
  ]
}] as RouteObject[]

export const NavigationFunction = (Navigator: NavigateFunction, navigation_page:Pages) => {
  switch (navigation_page) {
    case Pages.home:
      Navigator(Pages.home)
    break
    case Pages.op_operations:
      Navigator("../"+Pages.op_operations)
    break
    case Pages.op_animals:
      Navigator("../"+Pages.op_animals)
    break
    case Pages.op_quickEntry:
      Navigator("../"+Pages.op_quickEntry)
    break
    default:
      console.log("Error page not found (404)???, [ToolsMenu]")
  }
}
